import React, { useEffect, useMemo, useState } from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { DialogContent, Divider, TextField } from "@material-ui/core";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import DataTable from "../../../components/data-table";
import ordersService from "../../../services/orders.service";
import brandsService from "../../../services/brands.service";
import glassesService from "../../../services/glasses.service";
import FormModalContent from "./../orders/form";
import { currencyFormat } from "../../../helpers";
import DialogTitle from "../../../components/dialog-title";
import { useSelector } from "react-redux";

const defaultKeys = [
  {
    field: "trackingCode",
    title: "کد رهگیری",
    active: true,
  },
  {
    field: "user.phoneNumber",
    title: "شماره تلفن",
    active: true,
  },
];

export default function UserOrders({ data, close }) {
  const { initials } = useSelector((state) => state.app);
  const userId = data.id;
  const [options, setOptions] = useState({ brands: [] });

  useEffect(() => {
    brandsService.getAllBrands().then(({ data }) => {
      setOptions((prev) => ({
        ...prev,
        brands: data || [],
      }));
    });
  }, []);

  const headerCells = useMemo(
    () => [
      {
        field: "trackingCode",
        title: "کد رهگیری",
        disableSort: true,
      },
      {
        field: "user",
        title: "نام مشتری",
        renderer: (v) => <span>{v.fullName}</span>,
      },
      {
        field: "user",
        title: "شماره تلفن",
        renderer: (v) => <span className="en">{v.phoneNumber}</span>,
      },
      {
        field: "status",
        title: "وضعیت",
        disableSort: true,
        renderer: (v) =>
          initials?.enums?.orderStatus?.find((s) => s.value === v)?.title || v,
      },
      {
        field: "totalAmount",
        title: "مبلغ فاکتور",
        renderer: (v) => currencyFormat(v),
      },
      {
        field: "deliveryDate",
        title: "تاریخ تحویل",
        date: true,
      },
      {
        field: "createDate",
        title: "تاریخ ایجاد",
        date: true,
      },
    ],
    [initials]
  );

  const filterForm = useMemo(
    () =>
      !initials || !options.brands
        ? undefined
        : {
            form: [
              {
                _type: "autocomplete",
                _empty: "",
                name: "brandIds",
                options: options.brands.map((item) => ({
                  ...item,
                  value: item.id,
                  title: item.name,
                })),
                valueSelector: "value",
                labelSelector: "title",
                label: "برندها",
                disableClearable: false,
              },
              {
                _type: "customContent",
                content: function SearchContent(values) {
                  const [glasses, setGlasses] = useState([]);
                  const searchInGlassTitle = async (event) => {
                    const search = event.target.value;
                    const res = await glassesService.getGlasses([`search=${search}`]);
                    setGlasses(res.data.items);
                  };

                  const changeInGlassTitle = (event, value) => {
                    if (!value) {
                      values.setFieldValue("glassId", "");
                      values.setFieldValue("glass", null);
                      return;
                    }
                    values.setFieldValue("glassId", value.id);
                    values.setFieldValue("glass", value);
                  };

                  return (
                    <MuiAutocomplete
                      name="glassId"
                      multiple={false}
                      options={glasses}
                      onKeyUp={searchInGlassTitle}
                      getOptionLabel={(option) => `${option.name}`}
                      defaultValue={values.values.glass}
                      noOptionsText="هیچ گزینه ای یافت نشد."
                      onChange={changeInGlassTitle}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          fullWidth
                          label="مدل عینک"
                        />
                      )}
                    />
                  );
                },
              },
              {
                _type: "hidden",
                _empty: userId,
                name: "userId",
              },
              {
                _type: "autocomplete",
                _empty: null,
                name: "status",
                options: initials.enums.orderStatus,
                valueSelector: "value",
                labelSelector: "title",
                label: "وضعیت",
              },
            ],
          },
    [initials, options, userId]
  );

  return (
    <>
      <DialogTitle onClose={() => close()}>سفارشات {data.fullName}</DialogTitle>
      <Divider />
      <DialogContent className="py-3">
        <DataTable
          headCells={headerCells}
          searchKeys={defaultKeys}
          rowActions={[
            {
              modalProps: { maxWidth: "md" },
              icon: <InfoOutlinedIcon />,
              modalContent: (props) => <FormModalContent {...props} />,
            },
          ]}
          backend={ordersService.getOrdersUrl}
          title="سفارشات"
          order={{ order: "ASC", orderBy: "createDate" }}
          filterForm={filterForm}
        />
      </DialogContent>
    </>
  );
}
